import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminLabNewRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/labs/new',
}).lazy(() => import('pages/admin/Labs/AdminLabNewPage/AdminLabNewPage').then((d) => d.Route));
